import { render, staticRenderFns } from "./CheckBox.vue?vue&type=template&id=4ebd7707&"
import script from "./check-box.ts?vue&type=script&lang=ts&"
export * from "./check-box.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports